import { Component, OnInit } from '@angular/core'
import { OrderDetailsService, OrderDetailTotalsComponent } from '@spartacus/order/components'

@Component({
    selector: 'app-custom-order-detail-totals',
    templateUrl: './custom-order-detail-totals.component.html',
    styleUrls: ['./custom-order-detail-totals.component.scss'],
    standalone: false
})
export class CustomOrderDetailTotalsComponent extends OrderDetailTotalsComponent implements OnInit {
  constructor(protected orderDetailsService: OrderDetailsService) {
    super(orderDetailsService)
  }
  ngOnInit() {
    super.ngOnInit()
  }
}
